import { render } from "./ClientEventTypeSelect2.vue?vue&type=template&id=296c554c"
import script from "./ClientEventTypeSelect2.vue?vue&type=script&lang=js"
export * from "./ClientEventTypeSelect2.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__